import * as React from "react";
import styled from "../../../styled/index";
import {RestaurantUtils} from "../../../../common/utils/restaurant";

export const OrderStatusBackground = styled("div")<{ status: OrderStatuses }>`
  background: ${({status}) => RestaurantUtils.order.color(status)};
  color: white;
`;

export const OrderStatusText = styled("div")<{ status: OrderStatuses }>`
  color: ${({status}) => RestaurantUtils.order.color(status)};
`;
